import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { JobDescription } from '@/types.ts';
import { listJobDescriptions } from '@/libs/api/jobDescriptionService';

export const useJobOptions = (enabled: boolean) => {
  const { data } = useQuery({
    queryKey: ['job-description-options'],
    enabled,
    queryFn: () => listJobDescriptions({ page: 1, page_size: 100 }),
    staleTime: 30_000,
  });

  return useMemo<JobDescription[]>(
    () =>
      (data?.items || []).map((item) => ({
        id: item.id,
        title: item.title,
        department: item.department || '',
        location: item.location || '',
        type: 'Full-time',
        status: 'Open',
        description: '',
        requirements: [],
        postedDate: new Date(item.created_at).toISOString().split('T')[0] || '',
      })),
    [data],
  );
};
